
const drawerWidth = 265;

export const CustomNavStyle = theme => ({
    root: {
        display: 'flex',
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginLeft: 24,
        marginRight: 24,
    },
    hide: {
        display: 'none',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 1,
        whiteSpace: 'nowrap',
    },
    drawerOpen: {
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerClose: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden',
        width: theme.spacing.unit * 7 + 1,
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing.unit * 9 + 1,
        },
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    toolbarRight: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    iconClose: {
        margin: 0,
        padding: '12px 12px'
    },
    iconOpen: {
        marginTop: 5,
        marginRight: 15
    },
    ioteraCollapseButton: {
        borderRadius: '5px',
        cursor: 'pointer',
        // , &$focusVisible
        '&:hover': {
            'text-decoration': 'none',
            backgroundColor: '#EDEDED'
        },
        paddingTop: 3,
        paddingBottom: 2,
        marginRight: 15
    },
    tabSelected: {
        color: '#fff'
    },
    name: {
        display: 'inline-block',
        'text-transform': 'capitalize',
        'font-size': '90%',
        alignItems: 'center',
        transform: 'translate(0, 1.1px)',
    },
    navListTitle: {
        padding: '24px 36px',
        'font-size': '90%',
        'text-transform': 'capitalize',
        'font-weight': 'bold',
        position: 'relative',
        '&:before': {
            position: 'absolute',
            content: "",
            width: '15px',
            height: '2px',
            bottom: 0,
            background: '$site-nav-list-hover-color',
        }
    },
    listUnstyled: {
        padding: 0,
        listStyle: 'none'
    },
    ioteraNav: {
        cursor: 'pointer',
        color: '#000',
        fontWeight: 400,
        marginRight: 20,
        padding: '0px 10px 6px 2px',
        borderRadius: '5px',
        alignItems: 'center',
        justifyContent: 'center',
        '&:hover': {
            'text-decoration': 'none',
            backgroundColor: '#EDEDED'
        },
    },
    active: {
        backgroundColor: '#4D2C91',
        alignItems: 'center',
        '&:hover': {
            'text-decoration': 'none',
            backgroundColor: '#351E65'
        },
    },
    ioteraNavClose: {
        cursor: 'pointer',
        color: '#000',
        fontWeight: 400,
        margin: '5px 5px',
        overflowX: 'hidden',
        borderRadius: '5px',
        alignItems: 'center',
        justifyContent: 'center',
        width: theme.spacing.unit * 7 - 15,
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing.unit * 9 - 10,
        },
        '&:hover': {
            'text-decoration': 'none',
            backgroundColor: '#EDEDED'
        },
    }
});
